var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWsCartFooterDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Home_-disabled",
    "data-name": "Home -disabled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18252",
    "data-name": "Rectangle 18252",
    width: 24,
    height: 24,
    fill: "#97abb8",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-cart-2279749",
    transform: "translate(-70.769 -31.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38598",
    "data-name": "Path 38598",
    d: "M98.607,39.953a1.361,1.361,0,0,0-.968-.681L82.549,36.315A1.925,1.925,0,0,0,80.692,35H79.4a.609.609,0,1,0,0,1.216h1.29a.628.628,0,0,1,.645.608v7.907a3.141,3.141,0,0,0,3.226,3.041H95.208a.609.609,0,1,0,0-1.216H84.563a1.884,1.884,0,0,1-1.935-1.825V37.573l14.741,2.888a.218.218,0,0,1,.08.028c.024.032.047.224-.1.527l-1.167,2.357a1.587,1.587,0,0,1-1.251.751h-10a.609.609,0,1,0,0,1.216h10a2.89,2.89,0,0,0,2.42-1.453l1.167-2.357a1.728,1.728,0,0,0,.093-1.578Z",
    transform: "translate(-5.988)",
    fill: "#97abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38599",
    "data-name": "Path 38599",
    d: "M194.389,420a1.889,1.889,0,1,0,1.889,1.889A1.891,1.891,0,0,0,194.389,420Zm0,2.519a.63.63,0,1,1,.63-.63A.63.63,0,0,1,194.389,422.519Z",
    transform: "translate(-115.538 -371.618)",
    fill: "#97abb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38600",
    "data-name": "Path 38600",
    d: "M404.389,420a1.889,1.889,0,1,0,1.889,1.889A1.891,1.891,0,0,0,404.389,420Zm0,2.519a.63.63,0,1,1,.63-.63A.63.63,0,0,1,404.389,422.519Z",
    transform: "translate(-317.796 -371.618)",
    fill: "#97abb8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsCartFooterDisabled);
export default __webpack_public_path__ + "static/media/wsCartFooterDisabled.40c928b245ac7b24ded6cdb47ed30372.svg";
export { ForwardRef as ReactComponent };